import script from "./ActivatedAccountHistoricalStats.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivatedAccountHistoricalStats.vue?vue&type=script&setup=true&lang=ts"

import "./ActivatedAccountHistoricalStats.vue?vue&type=style&index=0&id=bdc8b958&scoped=true&lang=css"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdc8b958"]])

export default __exports__